// Port of api/fuel/app/classes/insights/hindex/counts.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'counts',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_plays || !owner.get_count_plays()) return {}

        var counts = {}
        for (var i = 1; i <= 6; i++) {
            counts[i] = { o: 0, r: 0, b: 0 }
        }

        var collectionIndex = this._data.current.get_index_level()
        if (!collectionIndex.length) return {}

        var gameCounts = Util.query(
            'SELECT game_players_min, game_players_max, game_players_community' +
            ' FROM game WHERE game_id IN (' + Util.in(collectionIndex) + ')'
        )

        for (var gi = 0; gi < gameCounts.length; gi++) {
            var game = gameCounts[gi]
            var pc = null
            try { pc = JSON.parse(game.game_players_community) } catch (e) { pc = null }

            for (var p = 1; p <= 6; p++) {

                if (p >= parseInt(game.game_players_min, 10) && p <= parseInt(game.game_players_max, 10)) {
                    counts[p].o++
                }

                if (pc && pc[p]) {
                    if (pc[p].b + pc[p].r > pc[p].n) {
                        counts[p].r++
                    }
                    if (pc[p].b > pc[p].r + pc[p].n) {
                        counts[p].b++
                    }
                }

            }
        }

        return {
            counts: counts
        }

    }
})
